// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem4,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    TextValidatorText,
    TextValidatorTextMultiline,
    TextValidatorNumber,
} from '../../../business-components/TextValidator/TextValidator'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import tipoCondicaoSaudeList from '../../../business-rules/List/tipoCondicaoSaudeList'

import tipoSituacaoDoencaList from '../../../business-rules/List/tipoSituacaoDoencaList'

import {
    IconButtonClearEntradaDados
 } from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
 } from '../../../business-components/Button/Button'

import {
    processaRegistrosDefaultIniciaisCondicaoSaude,
    processaAlteracaoCondicaoSaudeTipoCondicaoSaude,
} from './RiscosServiceCondicaoSaude'

const RiscosFormCondicaoSaude = ({ familiar, values, handleChange }) => {

    let tipoCondicaoSaudeSelecionada = ''

    processaRegistrosDefaultIniciaisCondicaoSaude(values, familiar)

    return (
        <FieldArray name="condicaoSaude">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm
                        style={{
                            display: values.condicaoSaude && values.condicaoSaude.filter(condicaoSaude => condicaoSaude.familiar === familiar).length > 0 ? "block" : "none"
                        }}
                    >
                        {values.condicaoSaude?.map((item, ind) => {
                            
                            tipoCondicaoSaudeSelecionada = pesquisaList(tipoCondicaoSaudeList, 
                                item.tipoCondicaoSaude)

                            return item.familiar === familiar ? (
                                <GridContainer
                                    key={ind}
                                >
                                    <GridItem12>
                                        <GridContainer>
                                            <GridItem1 />

                                            <GridItem4>
                                                <TextFieldTextSelect
                                                    name={`condicaoSaude[${ind}].tipoCondicaoSaude`}
                                                    label={LABEL.tipoCondicaoSaude}
                                                    value={item.tipoCondicaoSaude || ''}
                                                    onChange={handleChange}
                                                    list={tipoCondicaoSaudeList}
                                                    onBlur={processaAlteracaoCondicaoSaudeTipoCondicaoSaude(item)}
                                            />
                                            </GridItem4>
                                            <GridItem6
                                                style={{
                                                    display: 
                                                        !item.tipoCondicaoSaude
                                                            ? "block"
                                                            : "none"
                                                }}
                                            />
                                            <GridItem6
                                                style={{
                                                    display: 
                                                        item.tipoCondicaoSaude
                                                            ? "block"
                                                            : "none"
                                                }}
                                            >
                                                <TextValidatorTextMultiline
                                                    name={`condicaoSaude[${ind}].informacoesComplementares`}
                                                    label={LABEL.informacoesComplementares}
                                                    value={item.informacoesComplementares || ''}
                                                    onChange={handleChange}
                                                    tamMax={TAMMAX.informacoesComplementares}
                                                />
                                            </GridItem6>
                                            <GridItem1>
                                                <IconButtonClearEntradaDados
                                                    onClick={() =>
                                                        arrayHelpers.remove(ind)
                                                    }
                                                />
                                            </GridItem1>
                                        </GridContainer>

                                        {
                                            tipoCondicaoSaudeSelecionada.informaDadosDoenca === "S" ||
                                            tipoCondicaoSaudeSelecionada.informaDadosCirurgia === "S" 
                                                ?
                                                    <GridContainer>
                                                        <GridItem2 />

                                                        <GridItem3
                                                            style={{
                                                                display:
                                                                    tipoCondicaoSaudeSelecionada.informaDadosDoenca === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextValidatorNumber
                                                                name={`condicaoSaude[${ind}].idadeDesdeDoenca`}
                                                                label={LABEL.idadeDesdeDoenca}
                                                                value={item.idadeDesdeDoenca || ''}
                                                                onChange={handleChange}
                                                                numMin={NUMMIN.idade}
                                                                numMax={NUMMAX.idade}
                                                            />
                                                        </GridItem3>
                                                        <GridItem6
                                                            style={{
                                                                display:
                                                                    tipoCondicaoSaudeSelecionada.informaDadosDoenca === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextFieldTextSelect
                                                                name={`condicaoSaude[${ind}].tipoSituacaoDoenca`}
                                                                label={LABEL.tipoSituacaoDoenca}
                                                                value={item.tipoSituacaoDoenca || ''}
                                                                onChange={handleChange}
                                                                list={tipoSituacaoDoencaList}
                                                            />
                                                        </GridItem6>
                                                        <GridItem3
                                                            style={{
                                                                display:
                                                                    tipoCondicaoSaudeSelecionada.informaDadosCirurgia === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextValidatorNumber
                                                                name={`condicaoSaude[${ind}].idadeCirurgia`}
                                                                label={LABEL.idadeCirurgia}
                                                                value={item.idadeCirurgia || ''}
                                                                onChange={handleChange}
                                                                numMin={NUMMIN.idade}
                                                                numMax={NUMMAX.idade}
                                                            />
                                                        </GridItem3>
                                                        <GridItem6
                                                            style={{
                                                                display:
                                                                    tipoCondicaoSaudeSelecionada.informaDadosCirurgia === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextValidatorText
                                                                name={`condicaoSaude[${ind}].procedimentoCirurgia`}
                                                                label={LABEL.procedimentoCirurgia}
                                                                value={item.procedimentoCirurgia || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.procedimentoCirurgia}
                                                            />
                                                        </GridItem6>
                                                    </GridContainer>
                                                :
                                                    ''
                                        }
                                    </GridItem12>
                                </GridContainer>
                            )
                            : 
                            (
                                <DivForm
                                    key={ind}
                                />
                            )
                        })}
                    </DivForm>

                    <GridContainer>
                        <GridItem1 />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirCondicaoSaude} 
                            onClick={() => 
                                arrayHelpers.push({
                                    familiar: familiar
                                })
                            }
                        />
                    </GridContainer>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default RiscosFormCondicaoSaude